import { Icon } from '@/components/ui/icon';
import { Text } from '@/components/ui/text';
import { cn } from '@/lib/utils';
import {
  formatWorkspaceRole,
  getBusinessWorkspaceHref,
  type BusinessWorkspaceTab,
} from './workspace';
import { router } from 'expo-router';
import { Building2Icon, ShieldCheckIcon } from 'lucide-react-native';
import * as React from 'react';
import { Pressable, View } from 'react-native';

const TABS: { value: BusinessWorkspaceTab; label: string }[] = [
  { value: 'home', label: 'Home' },
  { value: 'events', label: 'Events' },
  { value: 'organization', label: 'Venue' },
];

export function BusinessShellNav({
  organizationID,
  organizationName,
  viewerRole,
  activeTab,
  activeVenue,
  activeVenueVerified = false,
  showSectionNav = true,
}: {
  organizationID: string;
  organizationName: string;
  viewerRole: string;
  activeTab: BusinessWorkspaceTab;
  activeVenue: { venue_id: string; venue_name: string } | null;
  activeVenueVerified?: boolean;
  showSectionNav?: boolean;
}) {
  return (
    <View className="gap-3 border-b border-border pb-2">
      <View className="flex-row items-center gap-3">
        {/* Venue icon — anchors both rows */}
        <View className="size-10 items-center justify-center rounded-md border border-primary-edge bg-primary-soft">
          <Icon
            as={activeVenue && activeVenueVerified ? ShieldCheckIcon : Building2Icon}
            size={18}
            className="text-primary"
          />
        </View>

        {/* Right column: org name tight above venue name */}
        <View className="min-w-0 flex-1">
          <View className="flex-row items-center gap-2">
            <Text
              variant="small"
              className="min-w-0 shrink font-semibold text-muted-foreground"
              numberOfLines={1}>
              {organizationName}
            </Text>
            <View className="rounded-full border border-primary/40 px-1.5 py-px">
              <Text className="text-[10px] font-semibold text-primary">
                {formatWorkspaceRole(viewerRole)}
              </Text>
            </View>
          </View>
          <Text
            className="text-[24px] font-bold leading-7 text-foreground"
            numberOfLines={2}>
            {activeVenue ? activeVenue.venue_name : 'No venue'}
          </Text>
        </View>
      </View>

      {showSectionNav ? (
        <View className="flex-row rounded-md border border-border bg-surface-alt p-1">
          {TABS.map((tab) => {
            const isActive = tab.value === activeTab;
            return (
              <Pressable
                key={tab.value}
                className={cn(
                  'flex-1 items-center rounded-sm px-3 py-2',
                  isActive ? 'bg-card' : 'bg-transparent'
                )}
                onPress={() =>
                  router.replace(
                    getBusinessWorkspaceHref(organizationID, tab.value) as never
                  )
                }>
                <Text
                  variant="small"
                  className={cn(
                    'font-semibold',
                    isActive ? 'text-foreground' : 'text-muted-foreground'
                  )}>
                  {tab.label}
                </Text>
              </Pressable>
            );
          })}
        </View>
      ) : null}
    </View>
  );
}
